/*
  Impulse t5932: the Help me choose finder (sections/imp-finder-page.liquid, template page.gear-finder.json).
  Draws the steps, the result and the Ask our team card from the JSON in #imp-fnd-config.
  The first question is the category (camera, lens, lighting, audio, support, drone, bags, film, accessories, or Not sure = ask our team);
  each category has its own two to four questions, some only after an earlier answer ("when"). Answers live in the address
  (?want=lens&mount=sony-e&lens=wide&budget=mid&used=1, any step may be skip), so Back works and a result can be shared.
  Products come live from templates/collection.gear-finder-picks.liquid on the category's own collection; nothing is typed in.
  No path ends empty: the result relaxes the narrowing answers, then the budget, then falls to the category, then to Ask our team.
*/
(function () {
  'use strict';

  const root = document.getElementById('imp-fnd');
  const cfgEl = document.getElementById('imp-fnd-config');
  if (!root || !cfgEl) return;
  const cfg = JSON.parse(cfgEl.textContent);

  const $ = (id) => document.getElementById(id);
  const el = {
    progress: $('imp-fnd-progress'), plabel: $('imp-fnd-plabel'), bar: $('imp-fnd-bar'),
    steps: $('imp-fnd-steps'), result: $('imp-fnd-result'),
    mine: $('imp-fnd-mine'), recap: $('imp-fnd-recap'),
    form: $('imp-fnd-form'), name: $('imp-fnd-name'), reach: $('imp-fnd-reach'), note: $('imp-fnd-note'),
    replyto: $('imp-fnd-replyto'), phone: $('imp-fnd-phone'), err: $('imp-fnd-err'),
    askCard: $('imp-fnd-ask-card'), sent: $('imp-fnd-sent'), sentH: $('imp-fnd-sent-h'), sentP: $('imp-fnd-sent-p'), back: $('imp-fnd-back')
  };
  const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const SENT_KEY = 'impFndSent';
  // Shopify brings the visitor back to this page after a post with the form's own sent flag (see the end of this file).
  const posted = !!root.querySelector('[data-imp-fnd-posted]');

  // The usage counter lives in assets/imp-finder-track.js; with it missing or failing the finder works the same.
  const track = (name, detail) => {
    try { if (window.impFinderTrack) window.impFinderTrack(name, detail); } catch (x) { /* counting must never reach the page */ }
  };

  const ICONS = {
    people: '<circle cx="9" cy="8" r="3"/><path d="M3.5 19c.5-3.5 2.6-5 5.5-5s5 1.5 5.5 5"/><circle cx="17" cy="9" r="2.4"/><path d="M16 14.2c2.6 0 4.2 1.3 4.7 4.3"/>',
    pin: '<path d="M12 21s-6-5.3-6-10a6 6 0 1 1 12 0c0 4.7-6 10-6 10z"/><circle cx="12" cy="11" r="2.2"/>',
    bolt: '<path d="M13 3L5 13h6l-1 8 8-10h-6l1-8z"/>',
    camera: '<path d="M4 8h3l1.5-2h7L17 8h3v11H4z"/><circle cx="12" cy="13" r="3.5"/>',
    video: '<rect x="3" y="6" width="13" height="12" rx="2"/><path d="M16 10.5l5-3v9l-5-3z"/>',
    both: '<circle cx="9" cy="12" r="6"/><circle cx="15" cy="12" r="6"/>',
    sprout: '<path d="M12 21v-8"/><path d="M12 13c0-4 3-6 7-6 0 4-3 6-7 6z"/><path d="M12 15c0-3-2-5-6-5 0 3 2 5 6 5z"/>',
    target: '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3"/>',
    star: '<path d="M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9z"/>',
    lens: '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5.5"/><path d="M9.5 10a3 3 0 0 1 2-1.4"/>',
    bulb: '<path d="M9.5 18h5M10.5 21h3"/><path d="M12 3a6 6 0 0 0-3.4 10.9c.5.4.8 1 .8 1.6V16h5.2v-.5c0-.6.3-1.2.8-1.6A6 6 0 0 0 12 3z"/>',
    mic: '<rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21M9 21h6"/>',
    tripod: '<rect x="9.5" y="2.5" width="5" height="3.5" rx="1"/><path d="M12 6v5M12 11L6.5 21M12 11l5.5 10M12 11v10"/>',
    drone: '<circle cx="5.5" cy="5.5" r="2.5"/><circle cx="18.5" cy="5.5" r="2.5"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/><path d="M7.3 7.3l3 3M16.7 7.3l-3 3M7.3 16.7l3-3M16.7 16.7l-3-3"/><rect x="10" y="10" width="4" height="4" rx="1"/>',
    bag: '<path d="M7 9a5 5 0 0 1 10 0v10.5a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 7 19.5z"/><path d="M9.5 4.5V3h5v1.5M7 14h10M10 17.5h4"/>',
    film: '<rect x="3" y="5" width="18" height="14" rx="1.5"/><path d="M7 5v14M17 5v14M3 9.5h4M3 14.5h4M17 9.5h4M17 14.5h4"/>',
    card: '<path d="M7 3h7l4 4v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"/><path d="M10 7v3M12.5 7v3M15 7v3"/>',
    check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
    alert: '<circle cx="12" cy="12" r="10"/><path d="M12 7v6"/><path d="M12 16.5v.1"/>'
  };
  const icon = (name) => '<svg class="imp-fnd__ic" viewBox="0 0 24 24" aria-hidden="true">' + ICONS[name] + '</svg>';
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  const CATS = cfg.cats;
  const MAX_PICKS = 6;
  const MAX_PAGES = 6; // a word in the title is looked for on at most this many pages of 50
  // The first question is the category. Its answers are the tiles; "Not sure" is a link under them (want=unsure) that goes to Ask our team.
  const WANT = Object.assign({ id: 'want' }, cfg.want);
  const UNSURE = 'unsure';

  // The camera's price bands as the storefront's own filter reads them (the same cut-offs as the See all link).
  const bandQuery = (p) => (p ? (p[0] ? '&filter.v.price.gte=' + p[0] : '') + (p[1] != null ? '&filter.v.price.lte=' + p[1] : '') : '');
  const inBand = (cents, p) => !p || ((!p[0] || cents >= p[0] * 100) && (p[1] == null || cents <= p[1] * 100));

  // The camera rules, first match wins. A skipped question is 'skip' and matches nothing, so it falls to Mirrorless.
  // Not mapped on purpose: DSLR, 360, Instant, Film, Trail and Security (the See all link reaches them; Film and instant is its own category).
  const resultType = (a) => {
    if (a.media === 'video' && a.skill === 'pro' && a.budget === 'high') return 'Cinema';
    if (a.media === 'photo' && a.shoot === 'people' && a.skill === 'pro' && a.budget === 'high') return 'Medium Format';
    if (a.media === 'video' && a.shoot === 'action' && a.budget === 'low') return 'Action';
    if (a.media === 'photo' && a.shoot === 'travel' && a.skill === 'start' && a.budget === 'low') return 'Point & Shoot';
    if (a.media === 'video' && a.shoot === 'people' && a.skill === 'start' && a.budget === 'low') return 'Camcorder';
    return 'Mirrorless';
  };

  // ---------- the questions that apply, and the state kept in the address ----------
  // A step with "when" only applies after that earlier answer. Several steps may share an id (the budget differs by kind): the first that applies wins.
  const depsOk = (st, s) => !st.when || Object.keys(st.when).every((k) => s[k] === st.when[k]);
  const depsMaybe = (st, s) => !st.when || Object.keys(st.when).every((k) => s[k] === undefined || s[k] === st.when[k]);
  const stepsOf = (s) => {
    const out = [WANT];
    const cat = CATS[s.want];
    if (cat) cat.steps.forEach((st) => { if (depsOk(st, s) && !out.some((o) => o.id === st.id)) out.push(st); });
    return out;
  };
  // How many questions this category has, counting one whose earlier answer is not given yet. Questions that only differ by the earlier
  // answer they wait for (the card type, the battery or the filter after "What do you need?") are one question.
  const plannedCount = (s) => {
    const cat = CATS[s.want];
    const slots = [];
    (cat ? cat.steps : []).forEach((st) => {
      if (!depsMaybe(st, s)) return;
      const shared = cat.steps.filter((o) => o.id === st.id).length > 1;
      const slot = st.when && !shared ? 'after ' + Object.keys(st.when).join(',') : st.id;
      if (slots.indexOf(slot) < 0) slots.push(slot);
    });
    return 1 + slots.length;
  };
  const answerOf = (q, v) => q.answers.find((a) => a.v === v);

  // Only answers that exist for the chosen category and apply to the answers before them are kept.
  const normalize = (raw) => {
    const s = { open: raw.open || 0 };
    const cat = CATS[raw.want];
    if (raw.want === UNSURE || cat) s.want = raw.want; else return s;
    if (cat) {
      cat.steps.forEach((st) => {
        if (st.id in s || !depsOk(st, s)) return;
        const v = raw[st.id];
        if (v === 'skip' || st.answers.some((a) => a.v === v)) s[st.id] = v;
      });
    }
    if (raw.used === '1' || raw.used === '0') s.used = raw.used;
    return s;
  };
  const ALL_KEYS = ['want', 'used'];
  Object.keys(CATS).forEach((c) => CATS[c].steps.forEach((st) => { if (ALL_KEYS.indexOf(st.id) < 0) ALL_KEYS.push(st.id); }));
  const readState = () => {
    const p = new URLSearchParams(location.search);
    const raw = {};
    ALL_KEYS.forEach((k) => { if (p.get(k)) raw[k] = p.get(k); });
    const o = parseInt(p.get('open'), 10);
    if (o >= 1) raw.open = o;
    const s = normalize(raw);
    if (s.open > stepsOf(s).length) s.open = 0;
    return s;
  };
  // Only our own parameters change; anything else in the address (a preview id, ?view=) is kept.
  const urlFor = (raw) => {
    const s = normalize(raw);
    const p = new URLSearchParams(location.search);
    ALL_KEYS.forEach((k) => p.delete(k));
    Object.keys(s).forEach((k) => { if (k !== 'open') p.set(k, s[k]); });
    if (s.open) p.set('open', s.open); else p.delete('open');
    const qs = p.toString();
    return location.pathname + (qs ? '?' + qs : '');
  };
  let state = readState();
  const openIndex = (s, steps) => {
    if (s.open && s.open <= steps.length) return s.open - 1;
    return steps.findIndex((st) => !s[st.id]);
  };
  // Used gear is left out unless the person says it is fine. The one exception is an answer that is used gear by nature (film cameras).
  const usedOn = (s) => {
    if (s.used === '1') return true;
    if (s.used === '0') return false;
    return stepsOf(s).some((st) => { const a = s[st.id] && answerOf(st, s[st.id]); return a && a.usedDefault; });
  };

  // ---------- the steps ----------
  const optHtml = (q, a, s) => {
    const picked = s[q.id] === a.v;
    const href = urlFor(Object.assign({}, s, { [q.id]: a.v, open: 0 }));
    const top = a.glyph ? '<span class="imp-fnd__glyph" aria-hidden="true">' + esc(a.glyph) + '</span>' : a.icon ? icon(a.icon) : '';
    return '<a class="imp-fnd__opt' + (top ? '' : ' imp-fnd__opt--plain') + (picked ? ' is-picked' : '') + '" href="' + esc(href) + '" data-answer="' + q.id + '" data-v="' + a.v + '"' + (picked ? ' aria-current="true"' : '') + '>' +
      top + '<b>' + esc(a.label) + '</b>' + (a.note ? '<small>' + esc(a.note) + '</small>' : '') + '</a>';
  };
  const optsClass = (q) => {
    const n = q.answers.length;
    return 'imp-fnd__opts' + (q.id === 'want' ? ' imp-fnd__opts--cats' : n >= 5 ? ' imp-fnd__opts--many' : '') + (n === 4 || n === 7 || n === 8 ? ' imp-fnd__opts--c4' : '');
  };
  const openRow = (q, i, s) => {
    const first = q.id === 'want';
    const skipHref = urlFor(Object.assign({}, s, { [q.id]: first ? UNSURE : 'skip', open: 0 }));
    return '<div class="imp-fnd__row imp-fnd__row--open" role="group" aria-labelledby="imp-fnd-q-' + (i + 1) + '">' +
      '<div class="imp-fnd__oh"><span class="imp-fnd__n" aria-hidden="true">' + (i + 1) + '</span>' +
      '<h2 class="imp-fnd__h2" id="imp-fnd-q-' + (i + 1) + '" tabindex="-1">' + esc(q.title) + '</h2></div>' +
      '<p class="imp-fnd__lead imp-fnd__lead--quiet">' + esc(q.lead) + '</p>' +
      '<div class="' + optsClass(q) + '">' + q.answers.map((a) => optHtml(q, a, s)).join('') + '</div>' +
      '<a class="imp-fnd__link" href="' + esc(skipHref) + '" data-answer="' + q.id + '" data-v="' + (first ? UNSURE : 'skip') + '">' + (first ? 'Not sure? Ask our team' : 'Not sure? Skip this one') + '</a></div>';
  };
  const doneRow = (q, i, s) => {
    const a = answerOf(q, s[q.id]);
    const href = urlFor(Object.assign({}, s, { open: i + 1 }));
    return '<div class="imp-fnd__row imp-fnd__row--done"><span class="imp-fnd__n" aria-hidden="true">' + icon('check') + '</span>' +
      '<div class="imp-fnd__t"><small>' + esc(q.title) + '</small><b>' + (a ? esc(a.label) : s[q.id] === UNSURE ? 'Not sure, ask our team' : 'Skipped') + '</b></div>' +
      '<a class="imp-fnd__chg" href="' + esc(href) + '" data-change="' + (i + 1) + '" aria-label="Change: ' + esc(q.title) + '">Change</a></div>';
  };
  const nextRow = (q, i) =>
    '<div class="imp-fnd__row imp-fnd__row--next"><span class="imp-fnd__n" aria-hidden="true">' + (i + 1) + '</span>' +
    '<div class="imp-fnd__t"><b>' + esc(q.title) + '</b></div><span class="imp-fnd__later">Next</span></div>';

  const drawSteps = (s, steps, oi) => {
    const total = oi >= 0 ? plannedCount(s) : steps.length;
    const label = oi >= 0 ? (s.want ? 'Question ' + (oi + 1) + ' of ' + total : 'Question 1') : steps.length + ' of ' + steps.length + ' answered';
    el.progress.hidden = false;
    el.plabel.textContent = label;
    el.bar.setAttribute('aria-label', label);
    el.bar.hidden = !s.want;
    el.bar.innerHTML = new Array(total + 1).join('<i></i>');
    Array.prototype.forEach.call(el.bar.children, (b, i) => b.classList.toggle('is-on', oi < 0 || i <= oi));
    el.steps.innerHTML = steps.map((q, i) => (i === oi ? openRow(q, i, s) : s[q.id] ? doneRow(q, i, s) : nextRow(q, i))).join('');
  };

  // ---------- the result ----------
  // What to ask the shop's collections for, in the order we relax it when nothing in stock matches:
  //  1 every answer   2 without the narrowing answers (what you shoot, how it is worn, a word in the title)   3 without the budget
  //  4 the answer's own collection with no filter   5 the category's collection.
  // The kind of thing (core answers: a mount, a type of light, a card) is kept as long as possible, because the wrong mount is no help.
  const planFor = (s) => {
    const cat = CATS[s.want];
    const camera = cat.rule === 'camera';
    const base = cat.collection || cfg.collection;
    let answerColl = '';
    const core = [], refine = [], kws = [], refined = [];
    let price = null;
    let res = cat.res;
    const type = camera ? resultType(s) : '';
    if (camera) res = Object.assign({}, cat.res, cfg.types[type]);
    stepsOf(s).slice(1).forEach((st) => {
      const v = s[st.id];
      if (!v || v === 'skip') return;
      const a = answerOf(st, v);
      if (st.id === 'budget') { price = a.p || null; return; }
      if (a.collection) answerColl = a.collection;
      if (st.core) {
        if (a.q) core.push(a.q);
        if (a.res) res = Object.assign({}, cat.res, a.res);
      } else if (!camera) {
        if (a.q) refine.push(a.q);
        if (a.kw) kws.push(a.kw);
        refined.push(a.label);
      }
    });
    if (camera) core.push('filter.p.m.custom.camera_type=' + encodeURIComponent(type));
    const coll = answerColl || base;
    const condition = usedOn(s) ? [] : ['filter.p.m.custom.gear_condition=New'];
    const levels = [];
    const add = (collection, parts, p, kw, why) => {
      const key = [collection, parts.join('&'), JSON.stringify(p), JSON.stringify(kw)].join('|');
      if (!levels.some((l) => l.key === key)) levels.push({ key: key, collection: collection, parts: parts.concat(condition), price: p, kw: kw, why: why });
    };
    const soft = refine.length > 0 || kws.length > 0;
    add(coll, core.concat(refine), price, kws.length ? kws : null, 'exact');
    if (soft) add(coll, core, price, null, 'refine');
    if (price) add(coll, core, null, null, 'budget');
    if (core.length) add(coll, [], null, null, 'plain');
    add(base, [], null, null, 'category');
    return { cat: cat, res: res, plain: Object.assign({}, cat.res), levels: levels, refined: refined, type: type, core: core.length > 0 };
  };
  const levelQuery = (l) => l.parts.map((p) => '&' + p).join('') + bandQuery(l.price);
  const seeAllHref = (l) => l.collection + (levelQuery(l) ? '?' + levelQuery(l).slice(1) : '');

  const picksCache = {};
  const getPage = (l, n) => {
    let url = l.collection + '?view=' + cfg.pickView + '&page=' + n + levelQuery(l);
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) url += '&preview_theme_id=' + encodeURIComponent(preview);
    if (!picksCache[url]) {
      picksCache[url] = fetch(url, { credentials: 'same-origin' })
        .then((r) => { if (!r.ok) throw new Error('picks ' + r.status); return r.text(); })
        .then((t) => JSON.parse(t));
      picksCache[url].catch(() => { delete picksCache[url]; });
    }
    return picksCache[url];
  };
  // One level of the plan: the first page of 50 and, when the answer is a word in the title (a travel tripod), the next pages too.
  const loadLevel = async (l) => {
    const first = await getPage(l, 1);
    let products = first.products || [];
    if (l.kw) {
      const re = new RegExp('\\b(' + [].concat.apply([], l.kw).join('|') + ')', 'i');
      if (products.filter((p) => re.test(p.title)).length < MAX_PICKS && (first.pages || 1) > 1) {
        const more = [];
        for (let n = 2; n <= Math.min(first.pages, MAX_PAGES); n++) more.push(getPage(l, n).catch(() => ({ products: [] })));
        (await Promise.all(more)).forEach((r) => { products = products.concat(r.products || []); });
      }
      products = products.filter((p) => re.test(p.title));
    }
    return { count: first.count || 0, products: products, kw: !!l.kw };
  };
  const looksUsed = (p) => p.used || /^used\b|\(used\)|open box/i.test(p.title);
  // Pinned products first (camera types only; in stock, inside the answered price band), then the live list in its own order:
  // in-stock products first, and only if that leaves room, items we order in (a labelled card) to fill the rest. Used gear only when it is fine.
  // The price shown is the cheapest variant's, and the storefront's price filter matches any variant, so the band is checked here too.
  const choose = (pinType, price, listed, withUsed) => {
    const out = [];
    const pins = (cfg.pins.find((p) => p.result === pinType) || { products: [] }).products;
    pins.forEach((p) => { if (out.length < MAX_PICKS && p.available && inBand(p.price, price)) out.push(p); });
    [false, true].forEach((labelled) => {
      listed.forEach((p) => {
        if (out.length < MAX_PICKS && p.available && !!p.label === labelled && inBand(p.price, price) && (withUsed || !looksUsed(p)) && !out.some((o) => o.id === p.id)) out.push(p);
      });
    });
    return out;
  };
  const cardHtml = (p) =>
    '<a class="imp-fnd__pc" href="' + esc(p.url) + '" title="' + esc(p.title) + '"><span class="imp-fnd__im">' +
    (p.image ? '<img src="' + esc(p.image) + '" alt="" width="240" height="240" loading="lazy">' : '') +
    (p.label ? '<span class="imp-fnd__tag">' + esc(p.label) + '</span>' : '') +
    '</span><span class="imp-fnd__nm">' + esc(p.title) + '</span><span class="imp-fnd__pr">' + esc(p.price_text) + '</span>' +
    '<span class="imp-fnd__sv">' + (p.was > 0 ? '<s class="imp-fnd__was">' + esc(p.was_text) + '</s><span class="imp-fnd__save">Save ' + esc(p.save_text) + '</span>' : '') + '</span></a>';
  const WORDS = ['none', 'one', 'two', 'three', 'four', 'five', 'six'];
  // The sentences the result can say about stock. The first is the one every in-stock result reads.
  const stockLine = (picks, inBudget) => {
    const n = picks.length;
    const stocked = picks.filter((p) => !p.label).length;
    const these = n === 1 ? 'This one is' : 'These ' + WORDS[n] + ' are';
    if (stocked === n) return these + ' in stock' + (inBudget ? ' and inside your budget' : '') + '.';
    const first = stocked === 0
      ? these + ' not on our shelf, so we order ' + (n === 1 ? 'it' : 'them') + ' in for you.'
      : WORDS[stocked][0].toUpperCase() + WORDS[stocked].slice(1) + ' in stock, and we order the other' + (n - stocked === 1 ? '' : 's') + ' in for you.';
    return first + (inBudget ? ' ' + (n === 1 ? 'It is' : n === 2 ? 'Both are' : 'All are') + ' inside your budget.' : '');
  };
  // Said above the picks when the first look found nothing in stock and a wider one did.
  const relaxLine = (plan, l, label) => {
    if (l.why === 'refine') return 'Nothing matched ' + plan.refined.join(' and ').toLowerCase() + ' exactly, so these are the closest ' + label + (l.price ? ' in your budget' : '') + '.';
    if (l.why === 'budget') return 'We have nothing in your budget right now. These are the ' + label + ' we do have.';
    return 'We could not match those answers. Here is what we have in ' + label + '.';
  };
  const askLink = '<a class="imp-fnd__btn imp-fnd__btn--quiet" href="#ask" data-ask>Ask our team to pick for me</a>';
  const usedHtml = (s) => {
    const on = usedOn(s);
    const href = urlFor(Object.assign({}, s, { used: on ? '0' : '1', open: 0 }));
    return '<div class="imp-fnd__used"><a class="imp-fnd__chip" href="' + esc(href) + '" role="switch" aria-checked="' + on + '" data-used="' + (on ? '0' : '1') + '">' + (on ? icon('check') : '') + 'Used is fine</a>' +
      '<span class="imp-fnd__hint">' + (on ? 'Used gear is included.' : 'Showing new gear only.') + '</span></div>';
  };

  // Counted once per distinct answer set, so Back and Forward do not count a result twice. The first result after the page came back from
  // sending was counted before the send, so it is skipped.
  let shownCategory = '';
  let shownResult = '';
  let skipNextResult = posted;
  const seenResults = new Set();
  const answerPath = (s) => stepsOf(s).slice(1).map((st) => s[st.id]).filter(Boolean).join('/');
  const reportResult = (s, result, outcome, picks, level) => {
    const key = JSON.stringify(Object.assign({}, normalize(s), { open: 0 })) + result;
    const skip = skipNextResult || seenResults.has(key);
    skipNextResult = false;
    seenResults.add(key);
    if (!skip) track('finished', { category: s.want, result: result, outcome: outcome, picks: picks, level: level, used: usedOn(s) ? 'yes' : 'no', budget: s.budget, path: answerPath(s) });
  };

  let resultToken = 0;
  const drawUnsure = (s, focus) => {
    shownCategory = UNSURE;
    shownResult = UNSURE;
    resultToken++;
    el.result.hidden = false;
    el.result.innerHTML = '<p class="imp-fnd__eyebrow">Your match &middot; our team</p>' +
      '<h2 class="imp-fnd__h2" id="imp-fnd-res-h" tabindex="-1">No problem. We will pick for you</h2>' +
      '<p class="imp-fnd__lead">Tell us what you shoot and what you can spend. A person at the shop reads it and replies with picks.</p>' +
      '<div class="imp-fnd__btns">' + '<a class="imp-fnd__btn imp-fnd__btn--main" href="#ask" data-ask>Ask our team to pick for me</a>' +
      '<a class="imp-fnd__btn imp-fnd__btn--quiet" href="' + esc(urlFor({ open: 1 })) + '" data-change="1">Or answer the questions</a></div>';
    reportResult(s, UNSURE, 'ask', 0, 'ask');
    if (focus) {
      $('imp-fnd-res-h').focus({ preventScroll: true });
      el.result.scrollIntoView({ block: 'start', behavior: reducedMotion ? 'auto' : 'smooth' });
    }
  };
  const drawResult = async (s, focus) => {
    if (s.want === UNSURE) { drawUnsure(s, focus); return; }
    const plan = planFor(s);
    const token = ++resultToken;
    shownCategory = s.want;
    const headFor = (res) => '<p class="imp-fnd__eyebrow">Your match &middot; ' + esc(res.label) + '</p>' +
      '<h2 class="imp-fnd__h2" id="imp-fnd-res-h" tabindex="-1">' + esc(res.heading) + '</h2>';
    shownResult = plan.type || plan.res.label;
    el.result.hidden = false;
    el.result.innerHTML = headFor(plan.res) + '<p class="imp-fnd__status">Finding your picks</p>';
    const done = () => {
      if (focus) {
        $('imp-fnd-res-h').focus({ preventScroll: true });
        el.result.scrollIntoView({ block: 'start', behavior: reducedMotion ? 'auto' : 'smooth' });
      }
    };
    try {
      for (let li = 0; li < plan.levels.length; li++) {
        const l = plan.levels[li];
        const data = await loadLevel(l);
        if (token !== resultToken) return;
        const picks = choose(plan.type, l.price, data.products, usedOn(s));
        if (!picks.length) continue;
        // The first look is the answered one; a wider look says so, and names the wider thing.
        const res = l.why === 'exact' || l.why === 'refine' || l.why === 'budget' ? plan.res : plan.plain;
        const wide = l.why !== 'exact';
        const more = data.kw ? 'See all ' + esc(res.label) : data.count > picks.length ? 'See all ' + data.count + ' ' + esc(res.label) : 'See all ' + esc(res.label);
        el.result.innerHTML = headFor(res) +
          (wide ? '<p class="imp-fnd__relax">' + esc(relaxLine(plan, l, res.label)) + '</p>' : '') +
          '<p class="imp-fnd__lead">' + esc(res.lead) + ' ' + esc(stockLine(picks, !!l.price)) + '</p>' +
          usedHtml(s) +
          '<div class="imp-fnd__pcs">' + picks.map(cardHtml).join('') + '</div>' +
          '<div class="imp-fnd__btns"><a class="imp-fnd__btn imp-fnd__btn--main" href="' + esc(seeAllHref(l)) + '">' + more + '</a>' + askLink + '</div>';
        shownResult = plan.type || res.label;
        reportResult(s, shownResult, 'picks', picks.length, l.why);
        done();
        return;
      }
      // Not one product in stock anywhere in the plan: the category and Ask our team.
      const last = plan.levels[plan.levels.length - 1];
      el.result.innerHTML = headFor(plan.plain) +
        '<p class="imp-fnd__lead">We do not have one of these in stock right now. You can see everything we list, or ask our team to find one.</p>' +
        usedHtml(s) +
        '<div class="imp-fnd__btns"><a class="imp-fnd__btn imp-fnd__btn--main" href="' + esc(last.collection) + '">See all ' + esc(plan.plain.label) + '</a>' + askLink + '</div>';
      reportResult(s, shownResult, 'none', 0, 'none');
      done();
    } catch (x) {
      if (token !== resultToken) return;
      const last = plan.levels[plan.levels.length - 1];
      el.result.innerHTML = headFor(plan.plain) +
        '<p class="imp-fnd__lead">We could not load the picks just now. You can see everything in ' + esc(plan.plain.label) + ', or ask our team to pick for you.</p>' +
        '<div class="imp-fnd__btns"><a class="imp-fnd__btn imp-fnd__btn--main" href="' + esc(last.collection) + '">See all ' + esc(plan.plain.label) + '</a>' + askLink + '</div>';
      reportResult(s, shownResult, 'error', 0, 'error');
      done();
    }
  };

  // ---------- Ask our team ----------
  // The category comes first in the recap and in the note ("Gear finder: lens, sony e, landscapes & interiors, $500 to $1,500.").
  const answeredLabels = (s) => (s.want === UNSURE ? ['Not sure what I need'] : stepsOf(s).map((st) => (s[st.id] && s[st.id] !== 'skip' ? answerOf(st, s[st.id]).label : null)).filter(Boolean));
  const skippedNames = (s) => stepsOf(s).map((st) => (s[st.id] === 'skip' ? st.short : null)).filter(Boolean);
  const noteFor = (s) => {
    if (s.want === UNSURE) return 'Gear finder: I am not sure what kind of gear I need and would like help choosing.\n\n';
    const got = answeredLabels(s).map((l) => l.toLowerCase());
    const skipped = skippedNames(s);
    if (!got.length) return '';
    return 'Gear finder: ' + got.join(', ') + '.' + (skipped.length ? ' Not sure about: ' + skipped.join(', ') + '.' : '') + (s.want && usedOn(s) ? ' Used is fine.' : '') + '\n\n';
  };
  let prefill = '';
  let noteDirty = false;
  const drawAsk = (s) => {
    const got = answeredLabels(s);
    el.mine.hidden = !got.length;
    el.recap.innerHTML = got.map((l) => '<span class="imp-fnd__pick">' + icon('check') + esc(l) + '</span>').join('');
    if (!noteDirty) {
      prefill = noteFor(s);
      el.note.value = prefill;
    }
  };
  el.note.addEventListener('input', () => { noteDirty = el.note.value !== prefill; });

  const showError = (msg, box) => {
    el.err.hidden = false;
    el.err.innerHTML = icon('alert') + '<span>' + esc(msg) + '</span>';
    ['imp-fnd-name-box', 'imp-fnd-reach-box', 'imp-fnd-phone-box'].forEach((id) => { const b = $(id); if (b) b.classList.toggle('is-bad', id === box); });
  };
  const clearError = () => {
    el.err.hidden = true;
    ['imp-fnd-name-box', 'imp-fnd-reach-box', 'imp-fnd-phone-box'].forEach((id) => { const b = $(id); if (b) b.classList.remove('is-bad'); });
  };
  const isEmail = (v) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v);
  const isPhone = (v) => (v.replace(/\D/g, '').length >= 7) && !/[a-z]/i.test(v);

  const showSent = (name, reach, hadAnswers) => {
    el.sentH.textContent = 'Sent. Thank you' + (name ? ', ' + name : '') + '.';
    el.sentP.textContent = 'A person at the shop will read your ' + (hadAnswers ? 'answers' : 'note') + ' and reply' + (reach ? ' to ' + reach : '') + '. We are ' + cfg.hours + '.';
    el.askCard.hidden = true;
    el.sent.hidden = false;
    el.back.setAttribute('href', urlFor(state));
    el.sent.focus({ preventScroll: true });
    el.sent.scrollIntoView({ block: 'center', behavior: reducedMotion ? 'auto' : 'smooth' });
  };
  const backToPicks = () => {
    el.sent.hidden = true;
    el.askCard.hidden = false;
    noteDirty = false;
    el.reach.value = '';
    if (el.phone) el.phone.value = '';
    syncReach();
    drawAsk(state);
    const target = !el.result.hidden ? el.result : el.progress;
    target.scrollIntoView({ block: 'start', behavior: reducedMotion ? 'auto' : 'smooth' });
  };

  // The form is Shopify's own contact form and posts to /contact the ordinary way, so its bot check works as it does on every Shopify
  // form. We only keep the fields right.
  //  Phone or email (the default): what is typed is posted as the email when it looks like one and as the phone when it does not
  //  (the field's name switches as the person types), and is also posted as "Reply to".
  //  Email required (the section setting): Email is required and Phone is optional; both are posted as they are.
  const emailMode = root.dataset.contact === 'email';
  const replyTo = () => {
    const v = el.reach.value.trim();
    const ph = emailMode && el.phone ? el.phone.value.trim() : '';
    return ph ? v + ' / ' + ph : v;
  };
  const syncReach = () => {
    if (!emailMode) el.reach.name = isEmail(el.reach.value.trim()) ? 'contact[email]' : 'contact[phone]';
    el.replyto.value = replyTo();
  };
  ['input', 'change'].forEach((t) => el.reach.addEventListener(t, syncReach));
  if (el.phone) ['input', 'change'].forEach((t) => el.phone.addEventListener(t, syncReach));
  syncReach();
  // Heard on the window in the capture phase, so a refused form never reaches Shopify's own submit handling.
  window.addEventListener('submit', (e) => {
    if (e.target !== el.form) return;
    clearError();
    const name = el.name.value.trim();
    const reach = el.reach.value.trim();
    const refuse = (msg, box, field) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError(msg, box);
      field.focus();
    };
    if (!name) { refuse('Add your name so we know who to reply to.', 'imp-fnd-name-box', el.name); return; }
    if (emailMode) {
      if (!isEmail(reach)) { refuse('Add an email so we can reply.', 'imp-fnd-reach-box', el.reach); return; }
      if (el.phone.value.trim() && !isPhone(el.phone.value.trim())) { refuse('That phone number does not look right. Check it, or leave it empty.', 'imp-fnd-phone-box', el.phone); return; }
    } else if (!isEmail(reach) && !isPhone(reach)) {
      refuse('Add a phone number or an email so we can reply.', 'imp-fnd-reach-box', el.reach);
      return;
    }
    syncReach();
    // The form passed our checks and goes to Shopify. Whether Shopify took it is counted as ask_sent when the page comes back.
    track('ask_submit', { category: shownCategory, result: shownResult, answers: answeredLabels(state).length });
    try {
      sessionStorage.setItem(SENT_KEY, JSON.stringify({ name: name, reach: replyTo(), hadAnswers: answeredLabels(state).length > 0, back: urlFor(state) }));
    } catch (x) { /* private mode: the sent card is just plainer */ }
  }, true);

  // ---------- drawing and moving ----------
  const draw = (focus) => {
    const steps = stepsOf(state);
    const oi = openIndex(state, steps);
    drawSteps(state, steps, oi);
    if (oi >= 0) {
      resultToken++;
      el.result.hidden = true;
      el.result.innerHTML = '';
      if (focus) {
        const h = $('imp-fnd-q-' + (oi + 1));
        if (h) h.focus({ preventScroll: true });
        el.progress.scrollIntoView({ block: 'start', behavior: reducedMotion ? 'auto' : 'smooth' });
      }
    } else {
      drawResult(state, focus);
    }
    drawAsk(state);
  };
  const go = (next) => {
    state = normalize(next);
    history.pushState({ imp: 1 }, '', urlFor(state));
    draw(true);
  };

  // The counter's clicks, on any click (a new-tab click too): a product card, See all, Ask our team to pick for me.
  root.addEventListener('click', (e) => {
    const a = e.target.closest('a');
    if (!a || !root.contains(a)) return;
    if (a.classList.contains('imp-fnd__pc')) track('product_click', { category: shownCategory, result: shownResult, product: a.getAttribute('title') });
    else if (a.classList.contains('imp-fnd__btn--main') && el.result.contains(a) && !a.hasAttribute('data-ask')) track('see_all', { category: shownCategory, result: shownResult });
    else if (a.hasAttribute('data-ask')) track('ask_click', { category: shownCategory, result: shownResult });
    else if (a.hasAttribute('data-used')) track('used_toggle', { category: shownCategory, used: a.dataset.used === '1' ? 'yes' : 'no' });
  });

  root.addEventListener('click', (e) => {
    const a = e.target.closest('a');
    if (!a || !root.contains(a) || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    if (a.dataset.answer) {
      const id = a.dataset.answer;
      const v = a.dataset.v;
      const picked = answerOf(stepsOf(state).find((st) => st.id === id) || { answers: [] }, v);
      track('answered', { category: id === 'want' ? v : state.want, step: stepsOf(state).findIndex((st) => st.id === id) + 1, question: id, answer: v });
      e.preventDefault();
      let next = Object.assign({}, state, { [id]: v, open: 0 });
      // A different category starts clean: a budget for lenses means nothing for lighting.
      if (id === 'want' && v !== state.want) next = { want: v, open: 0 };
      if (picked && picked.usedDefault && state.used == null) next.used = '1';
      go(next);
    } else if (a.dataset.used) {
      e.preventDefault();
      go(Object.assign({}, state, { used: a.dataset.used, open: 0 }));
    } else if (a.dataset.change) {
      e.preventDefault();
      go(Object.assign({}, state, { open: parseInt(a.dataset.change, 10) }));
    } else if (a.hasAttribute('data-ask')) {
      e.preventDefault();
      $('ask').scrollIntoView({ block: 'start', behavior: reducedMotion ? 'auto' : 'smooth' });
      el.name.focus({ preventScroll: true });
    } else if (a.id === 'imp-fnd-back') {
      e.preventDefault();
      backToPicks();
    }
  });
  window.addEventListener('popstate', () => {
    state = readState();
    draw(false);
  });

  // After a post Shopify brings the visitor back to this page with the form's own sent flag. The answers were in the address before
  // the post, so they are put back, and the sent card replaces the form.
  let saved = null;
  if (posted) {
    try { saved = JSON.parse(sessionStorage.getItem(SENT_KEY) || 'null'); sessionStorage.removeItem(SENT_KEY); } catch (x) { saved = null; }
    if (saved && /^\/[^/]/.test(saved.back || '')) {
      history.replaceState({ imp: 1 }, '', saved.back);
      state = readState();
    }
  }
  // A person opened the finder (not the page coming back from a send). answers = how many were already in the address.
  if (!posted) track('opened', { answers: stepsOf(state).filter((st) => state[st.id]).length });
  draw(false);
  if (posted) {
    showSent(saved && saved.name, saved && saved.reach, saved ? saved.hadAnswers : false);
    // Counted once: the record made at Send is read and removed above, so a reload of this page does not count again.
    if (saved) track('ask_sent', { answers: saved.hadAnswers ? 'yes' : 'no' });
  }
}());
